import React from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import moment from "moment";
import EditDialog from "./EditDialog";

export default function TicketTypeListTable(props: any) {
  const { list, classes } = props;

  const getDate = (list: any) => {
    if (list.isVisible) {
      return <div>{`Updated ${moment(list.updatedAt).format(`L`)}`}</div>;
    }
    return `Created ${moment(list.updatedAt).format(`L`)}`;
  };

  return (
    <Paper className={classes.tableRoot}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead></TableHead>
          <TableBody>
            <TableRow key={list.id} tabIndex={-1}>
              <TableCell align="left" style={{ paddingLeft: "30px" }}>
                <div className={classes.attributeTitle}>Title</div>
              </TableCell>
              <TableCell align="left">
                <div className={classes.attributeTitle}>Email</div>
              </TableCell>
              <TableCell align="left">
                <div className={classes.attributeTitle}>Last Updated</div>
              </TableCell>
              <TableCell align="center">
                <div className={classes.attributeTitle}></div>
              </TableCell>
            </TableRow>
            {list &&
              list.length > 0 &&
              list.map((item: any) => (
                <TableRow key={item.id} hover role="checkbox" tabIndex={-1}>
                  <TableCell align="left">
                    <div className={classes.attributeTitle}>{item.title}</div>
                  </TableCell>
                  <TableCell align="left">
                    <div className={classes.attributeTitle}>{item.emailID}</div>
                  </TableCell>
                  <TableCell align="left">
                    <div className={classes.text}>{getDate(item)}</div>
                  </TableCell>

                  <TableCell align="right">
                    <EditDialog
                      id={item.id}
                      classes={classes}
                      title={"EDIT TICKET TYPE"}
                    ></EditDialog>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
